import { memo, useContext, useEffect, useState, useCallback } from "react";
import classes from "./DrinkBarExpand.module.css";
import CabinetContext from "../../../store/cabinet-context";
import SearchContext from "../../../store/search-context";

const DrinkBarExpand = (props) => {
  const searchCtx = useContext(SearchContext);
  const cabinetCtx = useContext(CabinetContext);

  const compareToCabinet = searchCtx.compareToCabinet;
  const searchIngredients = searchCtx.items;
  const cabinetIngredients = cabinetCtx.items;
  const [ingredientInCabinet, setIngredientInCabinet] = useState([]);
  const [ingredientInSearch, setIngredientInSearch] = useState([]);
  const cocktailIngredients = props.ingredients;

  useEffect(() => {
    const initialIngredientInCabinet = cocktailIngredients.map(
      checkIngredientInCabinet
    );
    setIngredientInCabinet(initialIngredientInCabinet);

    const initialIngredientInSearch = cocktailIngredients.map(
      checkIngredientInSearch
    );
    setIngredientInSearch(initialIngredientInSearch);
  }, []); // Empty dependency array ensures this effect runs only once


  // check if cocktail ingredient is in cabinet
  const checkIngredientInCabinet = (cocktailIngredient) => {
    console.log("check ingredient in cabinet");
    return cabinetIngredients.some(
      (cabinetIngredient) =>
        cabinetIngredient.title === cocktailIngredient.ingredient.title
    );
  };

  // check if cocktail ingredient is in search query
  const checkIngredientInSearch = (cocktailIngredient) => {
    console.log("check ingredient in search");
    if (searchIngredients.length > 0) {
      return searchIngredients.some(
        (searchIngredient) =>
          searchIngredient.title === cocktailIngredient.ingredient.title
      );
    }
    return false;
  };


  // set the colour of the ingredient depending on its presence in either the search query of the cabinet
  const ingredientBars = useCallback(() => {
    return cocktailIngredients.map((ing, index) => {
      let colour;
      compareToCabinet
        ? (colour = ingredientInCabinet[index] ? "#68bb59" : "#e85a4f")
        : (colour = ingredientInSearch[index] ? "#68bb59" : "#e85a4f");

      return (
        <div
          style={{
            borderColor: `${colour}`,
          }}
          className={classes.ingredient_bar}
          key={ing._id}
        >
          {ing.ingredient.title}
        </div>
      );
    });
  }, [ingredientInCabinet, ingredientInSearch, compareToCabinet, cocktailIngredients]);

  return (
    <div className={classes.drink_bar_expand} onClick={props.onClose}>
      {ingredientBars()}
    </div>
  );
};

export default memo(DrinkBarExpand);
